import { keyBy } from 'lodash';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import {
  baseFiltersOptions,
  type FilterSelectType,
  type FilterType,
  type LocationFilters,
} from '~/components/FiltersMenu/types';
import { getFilterProps } from '~/components/FiltersMenu/utils/getFilterProps';
import { type SelectedFilter } from '~/store/filters/types';

export const getLocationFiltersOptions = ({
  selectedFilters,
  locationFilters,
  onSelect,
  disabledFilters,
}: {
  selectedFilters: SelectedFilter[];
  locationFilters: LocationFilters[];
  onSelect: FilterSelectType;
  disabledFilters?: FilterType[];
}) => {
  const selectedFiltersTypes = keyBy(selectedFilters, 'type');

  const options: DropdownMenuOption[] = locationFilters.map((locationFilter) => ({
    ...getFilterProps({
      type: locationFilter,
      onSelect: onSelect,
      isSelected: !!selectedFiltersTypes[locationFilter],
      disabled: disabledFilters?.includes(locationFilter),
    }),
    label: baseFiltersOptions[locationFilter].label,
    prefix: null,
    type: 'item',
  }));

  return options;
};
